import {
  CameraFocusSelectedObjectsCommand,
  CenterCameraOnSceneCommand,
  Command, NotUndoableCommandError,
  Viewer,
} from '@stereograph/teiaviewer';

export class SetupCreateAnomalySceneCommand extends Command {
  readonly name = 'SetupCreateAnomalySceneCommand';
  override readonly isUndoable = false;

  constructor(viewer: Viewer) {
    super(viewer);
  }

  protected override async _do() {
    const guids = new Set<string>(this.viewer.scene.objectSelection.getUuids());

    if (guids.size) {
      const focusCommand = new CameraFocusSelectedObjectsCommand(this.viewer, {
        duration: 0.005,
      });

      return focusCommand.execute();
    }

    const centerOnSceneCommand = new CenterCameraOnSceneCommand(this.viewer, {
      duration: 0.005,
    });

    return centerOnSceneCommand.execute();
  }

  protected override async _undo() {
    throw new NotUndoableCommandError(this);
  }
}
